/**
 * Calendly URL: override with VUE_APP_CALENDLY_URL at build time when needed.
 */
const DEFAULT_CALENDLY_URL = 'https://calendly.com/d/ct5v-bbb-r44/one-off-meeting';

export function calendlyUrl() {
  const v = process.env.VUE_APP_CALENDLY_URL;
  if (v && String(v).trim()) return String(v).trim();
  return DEFAULT_CALENDLY_URL;
}
